(() => {
  if (window.sekageStorefrontReady) return;
  window.sekageStorefrontReady = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  // iOS Safari only applies :active while a touch listener exists; this one lets every pressed state
  // in the stylesheets show the moment a finger lands.
  document.addEventListener('touchstart', () => {}, {passive: true});
  // Visitor-facing text comes from the locale files, through #sk-strings in theme.liquid.
  const strings = (() => {
    try { return JSON.parse(document.getElementById('sk-strings')?.textContent || '{}'); } catch { return {}; }
  })();
  function setup(root = document) {
    root.querySelectorAll('[data-sk-rail-section]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const rail = section.querySelector('[data-sk-rail]');
      const buttons = section.querySelectorAll('[data-sk-rail-direction]');
      const update = () => buttons.forEach(button => {
        const back = Number(button.dataset.skRailDirection) < 0;
        button.disabled = back ? rail.scrollLeft < 2 : rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
      });
      buttons.forEach(button => button.addEventListener('click', () => rail.scrollBy({left: Number(button.dataset.skRailDirection) * rail.clientWidth * .85, behavior: reduced.matches ? 'instant' : 'smooth'})));
      rail.addEventListener('scroll', update, {passive: true});
      new ResizeObserver(update).observe(rail);
      update();
      draggableRail(rail);
    });
  }
  // With a mouse the rail can be dragged the way it is swiped on a phone (touch already scrolls natively).
  // On release the throw is projected forward like scroll deceleration, and the rail settles on the card
  // nearest where it would have come to rest, carrying the hand's speed into that last move.
  function draggableRail(rail) {
    const motion = window.SekageMotion;
    if (!motion) return;
    const track = motion.tracker();
    let drag = null;
    let glide = null;
    let swallowUntil = 0;
    const settle = () => { rail.style.removeProperty('scroll-snap-type'); delete rail.dataset.skDragging; };
    rail.addEventListener('dragstart', event => event.preventDefault());
    rail.addEventListener('click', event => {
      if (performance.now() > swallowUntil) return;
      swallowUntil = 0;
      event.preventDefault();
      event.stopPropagation();
    }, true);
    rail.addEventListener('wheel', () => { if (glide?.running) { glide.stop(); settle(); } }, {passive: true});
    rail.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      glide?.stop();
      drag = {id: event.pointerId, x0: event.clientX, from: rail.scrollLeft, active: false};
      track.reset();
      track.add(event.clientX, 0);
    });
    rail.addEventListener('pointermove', event => {
      if (!drag || event.pointerId !== drag.id) return;
      track.add(event.clientX, 0);
      const dx = event.clientX - drag.x0;
      if (!drag.active) {
        if (Math.abs(dx) < 6) return;
        drag.active = true;
        try { rail.setPointerCapture(event.pointerId); } catch {}
        rail.dataset.skDragging = '';
        rail.style.scrollSnapType = 'none'; // snapping would fight the hand
      }
      rail.scrollLeft = drag.from - dx;
    });
    const release = event => {
      if (!drag || event.pointerId !== drag.id) return;
      track.add(event.clientX, 0); // a hand that paused before letting go reads as still
      const {active} = drag;
      drag = null;
      if (!active) return;
      swallowUntil = performance.now() + 400;
      const velocity = -track.velocity().x;
      const max = rail.scrollWidth - rail.clientWidth;
      const resting = Math.max(0, Math.min(max, rail.scrollLeft + motion.project(velocity)));
      const origin = rail.getBoundingClientRect().left - rail.scrollLeft;
      const stops = [...rail.children].map(card => Math.min(max, card.getBoundingClientRect().left - origin)).concat(max);
      const target = stops.reduce((best, stop) => Math.abs(stop - resting) < Math.abs(best - resting) ? stop : best, 0);
      glide = motion.spring({
        from: rail.scrollLeft, to: target, velocity, damping: 1, response: 0.45,
        onUpdate: x => { rail.scrollLeft = x; },
        onComplete: settle,
      });
    };
    rail.addEventListener('pointerup', release);
    rail.addEventListener('pointercancel', release);
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-sk-motion]');
    if (!button) return;
    const campaign = button.closest('[data-sk-campaign]');
    const paused = campaign.classList.toggle('sk-campaign--paused');
    button.setAttribute('aria-pressed', String(paused));
  });
  setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));

  // Product gallery (Turbo's Flickity). Its default physics wobble before settling; a stiffer pull with
  // more friction lands each photo in one clean move, like a critically damped spring. Turbo builds the
  // slider after its own scripts load, so the settings are applied once the slider appears.
  const firmGallery = () => {
    let pending = false;
    document.querySelectorAll('.sk-product-page .flickity-enabled').forEach(element => {
      // Turbo builds it through the jQuery plugin, which keeps the instance in jQuery's data store.
      const slider = window.jQuery?.(element).data('flickity') || window.Flickity?.data(element);
      if (!slider) { pending = true; return; }
      if (slider.skFirm) return;
      slider.skFirm = true;
      slider.options.selectedAttraction = 0.04;
      slider.options.friction = 0.38;
    });
    return !pending;
  };
  if (document.querySelector('.sk-product-page') && 'MutationObserver' in window) {
    const galleryWatch = new MutationObserver(() => { if (document.querySelector('.sk-product-page .flickity-enabled') && firmGallery()) galleryWatch.disconnect(); });
    galleryWatch.observe(document.querySelector('.sk-product-page'), {subtree: true, attributes: true, attributeFilter: ['class']});
    setTimeout(() => galleryWatch.disconnect(), 15000);
    addEventListener('load', () => setTimeout(firmGallery, 0));
  }

  // Motion. Below-the-fold pieces enter once, as they arrive. Nothing is hidden unless this script
  // armed it, and only pieces that start off screen are armed, so nothing already visible blinks.
  const watching = 'IntersectionObserver' in window;
  const revealer = watching && new IntersectionObserver(entries => entries.forEach(entry => {
    if (!entry.isIntersecting) return;
    entry.target.dataset.skReveal = 'in';
    revealer.unobserve(entry.target);
  }), {rootMargin: '0px 0px -10% 0px'});
  // The campaign banner's slow drift is decoration; it only runs while the banner is on screen.
  const ambient = watching && new IntersectionObserver(entries => entries.forEach(entry => entry.target.classList.toggle('sk-campaign--offscreen', !entry.isIntersecting)));
  // A price that changes because the visitor picked a variant slides into place, so the change is noticed.
  let chosenAt = -Infinity;
  document.addEventListener('change', event => { if (event.target.closest?.('.sk-product-page')) chosenAt = performance.now(); });
  function setupMotion(root = document) {
    if (watching) {
      if (document.body.classList.contains('index')) {
        const homeTargets = Array.from(root.querySelectorAll('[data-sk-home-motion]'));
        if (root.matches?.('[data-sk-home-motion]')) homeTargets.unshift(root);
        homeTargets.forEach(element => {
          if (element.dataset.skReveal || element.getBoundingClientRect().top < innerHeight) return;
          if (element.hasAttribute('data-sk-home-stagger') && element.parentElement) {
            const siblings = Array.from(element.parentElement.querySelectorAll(':scope > [data-sk-home-stagger]'));
            element.style.setProperty('--sk-home-i', Math.min(Math.max(siblings.indexOf(element), 0), 3));
          }
          element.dataset.skReveal = 'armed';
          revealer.observe(element);
        });
      }
      root.querySelectorAll('[data-sk-rail], .sk-product-context, .sk-facts').forEach(element => {
        if (element.dataset.skReveal || element.getBoundingClientRect().top < innerHeight) return;
        if (element.matches('[data-sk-rail]')) [...element.children].forEach((card, index) => card.style.setProperty('--sk-i', Math.min(index, 3)));
        element.dataset.skReveal = 'armed';
        revealer.observe(element);
      });
      root.querySelectorAll('[data-sk-campaign]').forEach(campaign => ambient.observe(campaign));
    }
    root.querySelectorAll('.sk-product-page .product-block--price .modal_price').forEach(box => {
      if (box.dataset.skPriceReady) return;
      box.dataset.skPriceReady = 'true';
      const read = () => box.querySelector('.price-ui')?.textContent.replace(/\s+/g, ' ').trim() || '';
      let shown = read();
      new MutationObserver(() => {
        const now = read();
        if (now === shown) return;
        shown = now;
        if (performance.now() - chosenAt > 1500) return; // theme start-up renders, not a visitor's choice
        box.classList.remove('sk-price-swap');
        void box.offsetWidth;
        box.classList.add('sk-price-swap');
      }).observe(box, {childList: true, subtree: true, characterData: true});
      box.addEventListener('animationend', () => box.classList.remove('sk-price-swap'));
    });
  }
  setupMotion();
  document.addEventListener('shopify:section:load', event => setupMotion(event.target));

  // Turbo always requests native main-gallery arrows. Adapt only its marked Studio galleries
  // before Flickity construction; thumbnail sliders and every other theme gallery remain untouched.
  function adaptStudioGallery() {
    const install = () => {
      const jq = window.jQuery, original = jq?.fn?.flickity;
      if (!original || original.skStudioAdapter) return;
      const adapted = function(options, ...args) {
        if (options && typeof options === 'object' && this.toArray().some(element => element.matches('[data-sk-native-gallery-arrows="false"]'))) {
          return this.each(function() {
            const settings = this.matches('[data-sk-native-gallery-arrows="false"]') ? {...options, prevNextButtons:false, cellSelector:'.gallery-cell'} : options;
            original.call(jq(this), settings, ...args);
          });
        }
        return original.call(this, options, ...args);
      };
      Object.assign(adapted, original);
      adapted.skStudioAdapter = true;
      jq.fn.flickity = adapted;
    };
    install();
    const loader = window.loadFlickity;
    if (typeof loader !== 'function' || loader.skStudioAdapter) return;
    const adaptedLoader = function(...args) {
      return Promise.resolve(loader.apply(this,args)).then(result => { install(); return result; });
    };
    adaptedLoader.skStudioAdapter = true;
    window.loadFlickity = adaptedLoader;
  }

  // One set of real Studio blocks; anchors preserve editor order across responsive placement.
  const studioInstances = new Map();
  function setupProductStudio(root = document) {
    adaptStudioGallery();
    const pages = root.matches?.('[data-sk-product-page]') ? [root] : root.querySelectorAll?.('[data-sk-product-page]') || [];
    pages.forEach(page => {
      if (studioInstances.has(page)) return;
      const panel = page.querySelector('.product_section > .product__details');
      if (!panel) return;
      const cleanups = [], wide = matchMedia('(min-width:1024px)');
      const intro = document.createElement('div');
      intro.className = 'sk-studio-intro'; panel.parentElement.before(intro);
      const blocks = [...panel.children].filter(node => node.matches('[data-sk-block]')), groups = [];
      blocks.forEach((block, index) => {
        if (index && blocks[index - 1].dataset.skBlock === 'title' && block.dataset.skBlock === 'price') return;
        const marker = document.createComment('studio-block'); block.before(marker);
        let element = block; const next = blocks[index + 1];
        if (block.dataset.skBlock === 'title' && next?.dataset.skBlock === 'price') {
          element = document.createElement('div'); element.className = 'sk-studio-title-price';
          marker.after(element); element.append(block, next);
        }
        element.classList.add('sk-studio-block');
        groups.push({element, marker, blocks: element === block ? [block] : [block, next]});
      });
      // Do not mistake scripts or app-controlled hidden hosts for visible content. Ignore our own
      // visibility marker so asynchronously populated wrappers can become visible again.
      const hasContent = element => {
        if (element.hidden || ['SCRIPT', 'STYLE', 'TEMPLATE', 'NOSCRIPT'].includes(element.tagName)) return false;
        const style = getComputedStyle(element);
        if ((style.display === 'none' && !element.hasAttribute('data-sk-visible')) || style.visibility === 'hidden') return false;
        if (element.matches('input[type="hidden"], [aria-hidden="true"]:empty')) return false;
        if (element.matches('img,video,model-viewer,iframe,canvas,svg,button,select,textarea,input:not([type="hidden"]),shopify-payment-terms')) return true;
        return [...element.childNodes].some(node => node.nodeType === Node.TEXT_NODE ? Boolean(node.textContent.trim()) : node.nodeType === Node.ELEMENT_NODE && hasContent(node));
      };
      const boundaries = elements => {
        let previous = false;
        elements.forEach(element => {
          const visible = hasContent(element); element.dataset.skVisible = String(visible);
          element.toggleAttribute('data-sk-divider', visible && previous); if (visible) previous = true;
        });
      };
      const isIntro = group => group.blocks.every(block => ['title', 'price', 'rating'].includes(block.dataset.skBlock)
        || (block.dataset.skBlock === '@app' && !block.querySelector('.jdgm-review-widget')
          && block.querySelector('.jdgm-preview-badge,.spr-badge,.loox-rating,.product-rating,.vtl-pr-review-stars-snippet')));
      let frame = 0, dead = false, ui = null, slider = null;
      const wrap = page.querySelector('[data-product-gallery-wrapper]');
      const placeUi = () => {
        if (!ui || !wrap) return;
        const home = wrap.querySelector('.product_gallery') || wrap;
        if (ui.parentElement !== home) home.append(ui);
        const count = ui.querySelector('.sk-pdp-counter__count');
        if (count && slider) {
          const value = (slider.selectedIndex + 1) + (wide.matches ? ' / ' : '/') + slider.cells.length;
          if (count.textContent !== value) count.textContent = value;
          count.parentElement.hidden = slider.cells.length <= 1;
        }
      };
      const observer = new MutationObserver(() => schedule());
      const refresh = () => {
        frame = 0; if (dead) return; observer.disconnect();
        const price = page.querySelector('.product-block--price [data-price-ui]');
        // Turbo first resolves PriceUI through the form's .product__details ancestor. Wait for
        // that initialization before moving its real element; subsequent updates keep its reference.
        const priceReady = !price || !price.classList.contains('price-ui--loading');
        let opening = true;
        groups.forEach(group => {
          const eligible = isIntro(group); if (!eligible) opening = false;
          const above = priceReady && !wide.matches && page.dataset.skMobileIntro !== 'false' && opening && eligible;
          if (group.element.parentElement !== (above ? intro : panel)) {
            if (above) intro.append(group.element); else group.marker.after(group.element);
          }
        });
        boundaries([...intro.children]);
        boundaries(groups.filter(group => group.element.parentElement === panel).map(group => group.element));
        intro.hidden = ![...intro.children].some(element => element.dataset.skVisible === 'true');
        panel.querySelectorAll('.product-block--form').forEach(block => boundaries([...block.querySelectorAll('[data-sk-purchase-group]')]));
        placeUi();
        const watched = {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['hidden','style','class','aria-hidden']};
        observer.observe(panel, watched);
        observer.observe(intro, watched);
      };
      const schedule = () => { if (!frame && !dead) frame = requestAnimationFrame(refresh); };
      wide.addEventListener('change', schedule); cleanups.push(() => wide.removeEventListener('change', schedule));
      const setting = name => (wrap?.getAttribute(name) ?? page.getAttribute(name)) !== 'false';
      let tries = 0, unbindGallery = () => {};
      const mountGallery = () => {
        const element = wrap?.querySelector('.product_gallery.flickity-enabled');
        const current = element && (window.jQuery?.(element).data('flickity') || window.Flickity?.data(element));
        if (!current) return false;
        if (ui?.isConnected && slider === current) return true;
        unbindGallery(); ui?.remove(); slider = current;
        // Covers an initial gallery whose in-flight loader resolved before this script ran.
        if (element.matches('[data-sk-native-gallery-arrows="false"]')) {
          slider.options.prevNextButtons = false;
          slider.prevButton?.destroy(); slider.nextButton?.destroy();
        }
        ui = document.createElement('div'); ui.className = 'sk-pdp-gallery-ui';
        const button = (className, icon, label, action) => {
          const control = document.createElement('button'); control.type = 'button';
          control.className = 'sk-pdp-gallery-btn ' + className; control.setAttribute('aria-label', label);
          control.innerHTML = '<span class="' + icon + '" aria-hidden="true"></span>'; control.addEventListener('click', action); return control;
        };
        const counter = document.createElement('div'); counter.className = 'sk-pdp-counter';
        const count = document.createElement('span'); count.className = 'sk-pdp-counter__count';
        if (setting('data-sk-gallery-arrows')) counter.append(button('sk-pdp-gallery-btn--prev','icon-left-arrow',strings.previous || 'Previous image',() => slider.previous(true)));
        counter.append(count);
        if (setting('data-sk-gallery-arrows')) counter.append(button('sk-pdp-gallery-btn--next','icon-right-arrow',strings.next || 'Next image',() => slider.next(true)));
        ui.append(counter);
        if (setting('data-sk-gallery-lightbox') && wrap.querySelector('a.lightbox')) ui.append(button('sk-pdp-gallery-btn--zoom','icon-zoom',strings.zoom || 'Zoom',() => slider.selectedElement?.querySelector('a.lightbox')?.click()));
        const mounted = slider;
        const sync = () => { placeUi(); schedule(); }; mounted.on('select',sync); mounted.on('cellChange',sync);
        unbindGallery = () => { mounted.off('select',sync); mounted.off('cellChange',sync); };
        placeUi(); return true;
      };
      const wait = wrap && setInterval(() => { if (mountGallery() || ++tries > 100) clearInterval(wait); },150);
      const galleryObserver = wrap && new MutationObserver(() => { if (mountGallery() && wait) clearInterval(wait); });
      galleryObserver?.observe(wrap,{childList:true,subtree:true,attributes:true,attributeFilter:['class']});
      cleanups.push(() => { if (wait) clearInterval(wait); galleryObserver?.disconnect(); unbindGallery(); ui?.remove(); });
      studioInstances.set(page,() => {
        dead = true; observer.disconnect(); if (frame) cancelAnimationFrame(frame); cleanups.forEach(dispose => dispose());
        groups.forEach(group => {
          group.marker.after(group.element);
          if (group.element.classList.contains('sk-studio-title-price')) group.element.replaceWith(...group.blocks);
          else group.element.classList.remove('sk-studio-block');
          group.blocks.forEach(block => { delete block.dataset.skVisible; block.removeAttribute('data-sk-divider'); }); group.marker.remove();
        }); intro.remove(); studioInstances.delete(page);
      }); refresh();
    });
  }
  setupProductStudio();
  // Deferred storefront code can precede Turbo's utility definitions. DOMContentLoaded runs
  // before jQuery's queued product init, so its first loader call also receives the adapter.
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', adaptStudioGallery, {once:true});
  else adaptStudioGallery();
  document.addEventListener('shopify:section:load',event => setupProductStudio(event.target));
  document.addEventListener('shopify:section:unload',event => [...studioInstances].forEach(([page,dispose]) => { if (event.target === page || event.target.contains(page)) dispose(); }));

  // Feedback for an Add to Cart that leaves the page (the cart page, or the no-drawer fallback).
  // sekage-navigation.js handles the usual in-page add and shows its own sending state.
  const settle = button => { button.classList.remove('sk-is-sending'); button.removeAttribute('aria-busy'); };
  document.addEventListener('submit', event => {
    const form = event.target;
    const button = form.matches?.('form[action*="/cart/add"]') && (event.submitter || form.querySelector('button[name="add"]'));
    if (!button) return;
    setTimeout(() => {
      if (event.defaultPrevented) return;
      button.classList.add('sk-is-sending');
      button.setAttribute('aria-busy', 'true');
      setTimeout(() => settle(button), 10000);
    });
  });
  addEventListener('pageshow', event => { if (event.persisted) document.querySelectorAll('.sk-is-sending').forEach(settle); });

  // Product page purchase stage. The mobile purchase bar is retired: .sk-buy__atc is position:sticky and
  // rides the bottom of the screen in place. Two small helpers live here.
  //  1. Stuck state. A zero-height sentinel sits right after the sticky block; while the sentinel is below
  //     the viewport the block is stuck to the bottom edge, and html-free [data-sk-stuck] lets the CSS add
  //     a shadow. IntersectionObserver only: no scroll listeners, no layout reads.
  //  (Installments use Shopify's own shopify-payment-terms and its native dialog; nothing to relay.)
  function setupPurchaseStage(root = document) {
    root.querySelectorAll('.sk-product-page .sk-buy__atc').forEach(atc => {
      if (atc.dataset.skStageReady) return;
      atc.dataset.skStageReady = 'true';
      const sticky = atc.closest('[data-sk-sticky-atc]')?.dataset.skStickyAtc ?? atc.closest('[data-sk-product-page]')?.dataset.skStickyAtc;
      if (sticky === 'false' || !('IntersectionObserver' in window)) return;
      const sentinel = document.createElement('span');
      sentinel.className = 'sk-buy__sentinel';
      sentinel.setAttribute('aria-hidden', 'true');
      atc.after(sentinel);
      // Stuck = the sentinel (the ATC's natural resting place) is still below the visible screen.
      const stuckObserver = new IntersectionObserver(([entry]) => {
        const below = !entry.isIntersecting && entry.boundingClientRect.top >= (entry.rootBounds?.bottom ?? innerHeight);
        atc.toggleAttribute('data-sk-stuck', below);
      });
      stuckObserver.observe(sentinel);
      const unload = event => {
        if (!event.target.contains(atc)) return;
        stuckObserver.disconnect(); sentinel.remove();
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
    });
    // "Learn more" opens Shopify's own sample-plans dialog: it presses the native ⓘ control inside
    // shopify-payment-terms (open shadow root), whose icon is then hidden so there is one control.
    root.querySelectorAll('[data-sk-installments-learn]').forEach(learn => {
      if (learn.dataset.skReady) return;
      learn.dataset.skReady = 'true';
      const wrap = learn.closest('.sk-buy__installments');
      const disposers = [];
      let disposed = false;
      const nativeCta = () => wrap?.querySelector('shopify-payment-terms')?.shadowRoot?.querySelector('#shopify-installments-cta');
      const watched = new WeakSet();
      const link = () => {
        if (disposed) return false;
        const cta = nativeCta();
        const shadowRoot = wrap?.querySelector('shopify-payment-terms')?.shadowRoot;
        if (shadowRoot && !watched.has(shadowRoot)) {
          watched.add(shadowRoot);
          const shadowObserver = new MutationObserver(link);
          shadowObserver.observe(shadowRoot, { childList: true, subtree: true });
          disposers.push(() => shadowObserver.disconnect());
          // The dialog returns focus to the native control when it closes; hand it to our button instead.
          const restoreFocus = event => {
            if (learn.dataset.skOpened && event.target?.id === 'shopify-installments-cta') {
              delete learn.dataset.skOpened;
              learn.focus();
            }
          };
          shadowRoot.addEventListener('focusin', restoreFocus);
          disposers.push(() => shadowRoot.removeEventListener('focusin', restoreFocus));
        }
        learn.hidden = !cta;
        if (!cta) return false;
        const shadow = cta.getRootNode();
        // Hidden visually, not with display:none, so the dialog can still return focus to it.
        if (!shadow.querySelector('style[data-sk]')) {
          const style = document.createElement('style');
          style.dataset.sk = '';
          style.textContent = '#shopify-installments-cta{position:absolute!important;width:1px!important;height:1px!important;margin:-1px!important;padding:0!important;overflow:hidden!important;clip:rect(0 0 0 0)!important;clip-path:inset(50%)!important;white-space:nowrap!important;border:0!important}';
          shadow.append(style);
        }
        cta.setAttribute('tabindex', '-1');
        cta.setAttribute('aria-hidden', 'true');
        learn.hidden = false;
        return true;
      };
      const openPlans = () => {
        const cta = nativeCta();
        if (!cta) return;
        learn.dataset.skOpened = 'true';
        cta.click();
        // The focusin handler above returns focus here when the dialog closes; the flag expires if it never does.
        const expiry = setTimeout(() => { delete learn.dataset.skOpened; }, 120000);
        disposers.push(() => clearTimeout(expiry));
      };
      learn.addEventListener('click', openPlans);
      disposers.push(() => learn.removeEventListener('click', openPlans));
      link();
      if (!wrap) return;
      // Turbo and Shopify render the payment terms after load and again on variant change; the shadow
      // root can fill after insertion, so a short bounded retry covers what the observers miss.
      const termsObserver = new MutationObserver(link);
      termsObserver.observe(wrap, { childList: true, subtree: true });
      disposers.push(() => termsObserver.disconnect());
      let tries = 0;
      const retry = setInterval(() => { if (link() || ++tries > 40) clearInterval(retry); }, 250);
      const unload = event => {
        if (!event.target.contains(learn)) return;
        disposed = true;
        clearInterval(retry);
        disposers.forEach(dispose => dispose());
        delete learn.dataset.skReady;
        delete learn.dataset.skOpened;
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
    });
  }
  setupPurchaseStage();
  document.addEventListener('shopify:section:load', event => setupPurchaseStage(event.target));


  // Cart page. Turbo changes quantities with a background request, then reloads the cart; it has no
  // failure path, so its steppers stay disabled and nothing is said when a request fails. This adds
  // the failure message, announces the new subtotal after the reload, and keeps Checkout reachable on phones.
  function setupCart() {
    const form = document.querySelector('[data-cart-form="cart-template"]');
    const status = document.querySelector('[data-sk-cart-status]');
    const pending = 'sk-cart-updated';
    const remember = on => { try { on ? sessionStorage.setItem(pending, '1') : sessionStorage.removeItem(pending); } catch {} };
    let announce = false;
    try { announce = sessionStorage.getItem(pending) === '1'; } catch {}
    remember(false);
    // A short delay lets screen readers register the live region before its text arrives.
    if (announce && status) setTimeout(() => { status.textContent = status.dataset.updatedMessage || ''; }, 600);
    if (!form) return;

    const error = document.querySelector('[data-sk-cart-error]');
    // pagehide runs before an unloading page aborts its requests, and unlike beforeunload it keeps the back/forward cache.
    let leaving = false;
    addEventListener('pagehide', () => { leaving = true; });
    addEventListener('pageshow', () => { leaving = false; });
    const isChange = settings => /\/cart\/change(?:\.js)?(?:\?|$)/.test(settings?.url || '');
    const release = () => {
      form.removeAttribute('aria-busy');
      form.querySelectorAll('.js-change-quantity.is-disabled').forEach(button => button.classList.remove('is-disabled'));
      form.querySelectorAll('[data-cart-item].animated').forEach(item => item.classList.remove('animated', 'fadeOutLeft', 'fadeOutUp'));
    };
    const listen = () => {
      const $ = window.jQuery;
      if (!$) return;
      $(document).on('ajaxSend', (event, xhr, settings) => {
        if (!isChange(settings)) return;
        form.setAttribute('aria-busy', 'true');
        if (error) error.hidden = true;
        remember(true);
      });
      $(document).on('ajaxError', (event, xhr, settings) => {
        // Turbo submits the form straight after a removal, which aborts the request; that is not a failure.
        if (!isChange(settings) || leaving) return;
        remember(false);
        release();
        if (!error) return;
        // Reveal the empty alert first, then fill it, so screen readers announce it every time.
        error.textContent = '';
        error.hidden = false;
        setTimeout(() => { error.textContent = xhr.responseJSON?.description || error.dataset.errorMessage || ''; }, 50);
      });
      $(document).on('ajaxSuccess', (event, xhr, settings) => {
        if (!isChange(settings)) return;
        // When stock is short Turbo shows a warning and stays on the page instead of reloading.
        setTimeout(() => {
          const warning = form.querySelector('.warning--quantity');
          if (!warning || leaving) return;
          remember(false);
          release();
          if (status) status.textContent = warning.textContent.trim();
        });
      });
    };
    // jQuery loads after this script; every deferred script has run by DOMContentLoaded.
    if (window.jQuery) listen();
    else document.addEventListener('DOMContentLoaded', listen, {once: true});

    const bar = form.querySelector('[data-sk-cart-bar]');
    const main = form.querySelector('#checkout');
    if (!bar || !main) return;
    const phone = matchMedia('(max-width: 767px)');
    let queued = false;
    const setCartBarVisible = visible => document.documentElement.classList.toggle('sk-cart-bar-visible', visible);
    // Like the product page's purchase bar, this bar slides back down the way it came.
    const place = () => {
      queued = false;
      if (phone.matches && main.getBoundingClientRect().top > innerHeight) {
        bar.classList.remove('is-leaving');
        bar.hidden = false;
        setCartBarVisible(true);
      } else if (!bar.hidden && !bar.classList.contains('is-leaving')) {
        if (reduced.matches || !bar.getClientRects().length) {
          bar.hidden = true;
          setCartBarVisible(false);
        } else bar.classList.add('is-leaving');
      }
    };
    bar.addEventListener('animationend', event => {
      if (event.animationName !== 'sk-buy-bar-out' || !bar.classList.contains('is-leaving')) return;
      bar.classList.remove('is-leaving');
      bar.hidden = true;
      setCartBarVisible(false);
    });
    const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(place); } };
    addEventListener('scroll', schedule, {passive: true});
    addEventListener('resize', schedule, {passive: true});
    place();
  }
  setupCart();

  // Keep Shopify's original buttons and consent handlers; adjust presentation only.
  function styleCookieBanner() {
    const banner = document.getElementById('shopify-pc__banner');
    if (!banner || banner.dataset.skCookiesReady) return;
    const accept = banner.querySelector('#shopify-pc__banner__btn-accept');
    const necessary = banner.querySelector('#shopify-pc__banner__btn-decline');
    const preferences = banner.querySelector('#shopify-pc__banner__btn-manage-prefs');
    if (!accept || !necessary || !preferences) return;
    banner.dataset.skCookiesReady = 'true';
    const copy = strings.cookies;
    if (copy?.accept && copy.decline && copy.title && copy.text) {
      accept.textContent = copy.accept;
      necessary.textContent = copy.decline;
      if (copy.preferences) preferences.textContent = copy.preferences;
      const title = banner.querySelector('#shopify-pc__banner__body-title');
      if (title) title.textContent = copy.title;
      const policy = banner.querySelector('#shopify-pc__banner__body-policy-link');
      const paragraph = policy?.closest('p');
      if (paragraph) paragraph.replaceChildren(document.createTextNode(copy.text + ' '), policy);
    }
    accept.parentElement.replaceChildren(necessary, accept, preferences);
  }
  // The consent banner must only overlay the page: strip any bottom spacing added inline while it shows or after it closes.
  function releaseBannerSpace() {
    [document.documentElement, document.body].forEach(el => {
      if (el.style.paddingBottom) el.style.paddingBottom = '';
      if (el.style.marginBottom) el.style.marginBottom = '';
    });
  }
  releaseBannerSpace();
  new MutationObserver(releaseBannerSpace).observe(document.documentElement, {attributes: true, attributeFilter: ['style']});
  new MutationObserver(releaseBannerSpace).observe(document.body, {attributes: true, attributeFilter: ['style']});
  styleCookieBanner();
  new MutationObserver(records => {
    const bannerAdded = records.some(record => Array.from(record.addedNodes).some(node =>
      node.nodeType === 1 && (node.id === 'shopify-pc__banner' || node.querySelector('#shopify-pc__banner'))
    ));
    if (bannerAdded) styleCookieBanner();
  }).observe(document.body, {childList: true, subtree: true});

  // Preferences panel: every optional category starts checked each time the panel opens.
  (function consentPrefsDefaults() {
    let wasOpen = false;
    const check = () => {
      const prefs = document.getElementById('shopify-pc__prefs');
      if (!prefs) { wasOpen = false; return; }
      const open = prefs.getClientRects().length > 0;
      if (open && !wasOpen) {
        prefs.querySelectorAll('input[type="checkbox"]:not(:disabled):not(:checked)').forEach(box => {
          box.checked = true;
          box.dispatchEvent(new Event('input', {bubbles: true}));
          box.dispatchEvent(new Event('change', {bubbles: true}));
        });
      }
      wasOpen = open;
    };
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; check(); });
    }).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'open', 'aria-hidden']});
    check();
  })();

  // Country selector. Picking a grouped market (Europe) from outside it submits a default member
  // country; remember that the region itself was chosen so the region row, not that country, shows as
  // selected. Any other pick clears the memory. Visitors placed in a member country by Shopify are untouched.
  (function regionChoice() {
    const KEY = 'sk-region-choice';
    const read = () => {
      try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; }
    };
    const write = value => {
      try { value ? localStorage.setItem(KEY, JSON.stringify(value)) : localStorage.removeItem(KEY); } catch (e) {}
    };
    const lists = () => document.querySelectorAll('.disclosure--country [data-disclosure-list]');
    const isCurrentMarket = (list, handle) =>
      Array.from(list.querySelectorAll('.sk-localization__item--sub')).some(li => li.dataset.marketHandle === handle);

    document.addEventListener('click', event => {
      const button = event.target.closest?.('.disclosure--country [data-disclosure-list] button.disclosure__button');
      if (!button) return;
      const item = button.closest('li');
      const list = button.closest('[data-disclosure-list]');
      if (!item || !list) return;
      const handle = item.dataset.marketHandle;
      if (item.classList.contains('sk-localization__item--group')) {
        // Re-picking the region while inside it keeps whatever is remembered.
        if (!isCurrentMarket(list, handle)) write({handle, country: button.value});
      } else {
        write(null);
      }
    }, true);

    const choice = read();
    if (!choice?.handle || !choice.country) return;
    lists().forEach(list => {
      const form = list.closest('form');
      const current = form?.querySelector('input[name="country_code"][data-disclosure-input]')?.value;
      if (current !== choice.country || !isCurrentMarket(list, choice.handle)) return;
      const group = Array.from(list.querySelectorAll('.sk-localization__item--group'))
        .find(li => li.dataset.marketHandle === choice.handle);
      const groupButton = group?.querySelector('button.disclosure__button');
      if (!groupButton) return;
      list.querySelectorAll('.disclosure-list__item--current').forEach(li => li.classList.remove('disclosure-list__item--current'));
      list.querySelectorAll('button[aria-current]').forEach(b => b.removeAttribute('aria-current'));
      group.classList.add('disclosure-list__item--current');
      groupButton.setAttribute('aria-current', 'true');
    });
  })();
})();
